
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import vSelect from "vue-select"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import LightDarkSwitch from "./Account/LightDarkSwitch.vue"
import UserImage from "./UserImage.vue"

import api from "@/services/api"

import User from "@/types/user"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"light-dark": LightDarkSwitch,
		"user-picture": UserImage
	}
})
export default class SlideMenu extends Vue {
	@Getter("getScreenWidth") public screenWidth!: number;
	@Getter("getMe") public me!: User;

	public show: boolean = false;
	public userExpanded: boolean = false;

	@Action("logOut") public logOut!: () => void;

	public open () {
		this.show = true
	}
	public close () {
		this.show = false
	}

	public get myPictureUrl (): string {
		return api.pictureUrl(this.me.id)
	}
}

